let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("eiJrL")).then(() => parcelRequire('5Y7e4'));